import React from "react";
const AttachmentContent = props => {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  return /*#__PURE__*/React.createElement("div", {
    id: props.id,
    style: props.style
  }, props.children);
};
export default AttachmentContent;